
import {getBonusHistoryList} from '../api/getBonusHistoryList';
import {setGetBonusHistoryListAction} from '../action';

const setGetBonusHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getBonusHistoryList(params);

            if (data.status === 'success') {
                dispatch(setGetBonusHistoryListAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetBonusHistoryList
}